// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__VVaxr","text":"style_text__mfQxZ","remove":"style_remove__RByxU"};